export const ar = {
  nav: { home: 'الرئيسية', about: 'من نحن', services: 'الخدمات', solutions: 'الحلول', offers: 'العروض الفنية', download: 'التحميل', support: 'الدعم الفني', contact: 'اتصل بنا', login: 'تسجيل الدخول', cta: 'احصل على جهاز' },
  hero: {
    brand: 'WiyakGPS', tagline: 'أدق… أسرع… أذكى',
    desc: 'منصة ذكية لتتبع المركبات وإدارة الأسطول ومراقبة الحركة لحظة بلحظة عبر الويب والموبايل.',
    cta1: 'ابدأ التتبع الآن', cta2: 'شاهد النظام',
    live: 'مباشر', sat: 'ثلاثة أقمار مقفلة', acc: 'دقة 2.5 متر',
    truck: 'TR-204 · بغداد ← أربيل', kmh: 'كم/س', scroll: 'مرر للأسفل',
  },
  marquee: ['تشغيل فضائي 99.98%', 'ممر أربيل–بغداد', 'تنبيهات أقل من 3 ثوانٍ', '14,250 وحدة أسطول متصلة', 'أجهزة IP67', 'استجابة 24/7 · العراق'],
  stats: [
    { v: '14,250', l: 'وحدة أسطول متصلة' },
    { v: '+450', l: 'مدينة ومنطقة مغطاة' },
    { v: '99.98%', l: 'تشغيل فضائي' },
    { v: '24/7', l: 'استجابة ودعم' },
  ],
  how: {
    eyebrow: 'كيف يعمل النظام', title: 'من المدار إلى شاشتك في ثوانٍ.',
    steps: [
      { t: 'القمر الصناعي', d: 'أقمار GPS تبث إشارات توقيت دقيقة من المدار.' },
      { t: 'المركبة', d: 'جهاز ويَك يقرأ الموقع وبيانات المركبة.' },
      { t: 'الإنترنت', d: 'تنتقل البيانات عبر 4G-LTE بقنوات مشفرة.' },
      { t: 'WiyakGPS', d: 'منصتنا تعالج المواقع والتنبيهات والتقارير.' },
      { t: 'لوحة التحكم', d: 'تشاهد كل شيء مباشرة على الويب والموبايل.' },
    ],
  },
  vehicles: {
    eyebrow: 'أنواع المركبات', title: 'أنظمة التتبع لجميع أنواع المركبات.',
    sub: 'من الشاحنات الثقيلة إلى التك تك — منصة واحدة، حساب واحد، وكل مركبة مغطاة.',
    items: [
      { name: 'شاحنات نقل', tag: 'نقل ثقيل · نفط وغاز' },
      { name: 'سيارات صالون', tag: 'تاكسيات · مندوبين' },
      { name: 'فان التوصيل', tag: 'أساطيل التوصيل' },
      { name: 'باصات', tag: 'نقل موظفين وطلاب' },
      { name: 'دراجات نارية', tag: 'أساطيل التوصيل السريع' },
      { name: 'تك تك', tag: 'النقل المحلي' },
    ],
  },
  coverage: {
    eyebrow: 'التغطية', title: 'من دهوك إلى البصرة. خريطة واحدة حية.',
    sub: 'كل ممر ونقطة تفتيش ومعبر في العراق — متتبع لحظة بلحظة مع استشعار إشارة على مستوى المدن.',
    nodes: 'عقد حية', latency: 'متوسط الاستجابة', latencyV: '2.4s', online: 'متصل', hint: 'مرر فوق أي مدينة',
    cities: { duhok: 'دهوك', erbil: 'أربيل', mosul: 'الموصل', sulaymaniyah: 'السليمانية', kirkuk: 'كركوك', baghdad: 'بغداد', karbala: 'كربلاء', najaf: 'النجف', basra: 'البصرة' },
    legend: { truck: 'شاحنات', car: 'سيارات', van: 'فانات', bus: 'حافلات' },
  },
  dashboard: {
    eyebrow: 'مركز القيادة', title: 'لوحة تحكم احترافية لا تغمض.',
    sub: 'السرعة والوقود والنطاقات الجغرافية والتوقيف عن بُعد — حالة أسطولك كاملة في شاشة واحدة وعلى أي جهاز. هذه هي منصة WiyakGPS الفعلية.',
    openBtn: 'افتح المنصة',
  },
  bento: {
    eyebrow: 'القدرات', title: 'أجهزة دقيقة. برمجيات ذكية.',
    sub: 'ستة أنظمة تعمل كواحد — من المدار إلى الإشعال.',
    items: [
      { tag: '01 / المدار', title: 'تحديد فضائي ثلاثي', desc: 'GPS وGLONASS وGalileo معاً — إحداثيات كل 10 ثوانٍ بدقة 2.5 متر.' },
      { tag: '02 / تحكم', title: 'موقوف عن بُعد', desc: 'اقطع الإشعال من هاتفك — بأمان وفوري وموثق للامتثال.' },
      { tag: '03 / وقود', title: 'حماية الوقود من السرقة', desc: 'حساسات سعة تكشف سرقة الوقود والإنزال لحظياً.' },
      { tag: '04 / سلامة', title: 'ذكاء سلوك السائق', desc: 'الفرملة العنيفة والانعطاف والسرعة والتوقف — تقييم لكل سائق وتدريب لكل رحلة.' },
      { tag: '05 / التبريد', title: 'حساسات الحرارة', desc: 'مراقبة سلسلة التبريد بمعايير دوائية مع تنبيهات فورية وسجل كامل.' },
      { tag: '06 / صيانة', title: 'تشخيص آلي للصيانة', desc: 'فحوص صحية تلقائية تحجز الخدمة قبل أن تكلفك عطل شحنة.' },
    ],
  },
  apps: {
    eyebrow: 'التطبيقات والمنصات', title: 'أسطول واحد. كل الشاشات.',
    sub: 'تطبيقات أصلية ولوحة ويب وكونسول مكتبي وواجهة مفتوحة — أسطولك يتبعك في كل مكان.',
    cta: 'استكشف التطبيقات',
    platforms: [
      { name: 'تطبيق iOS', desc: 'خريطة حية وتنبيهات وتقارير في جيبك.', badge: 'App Store' },
      { name: 'تطبيق أندرويد', desc: 'تتبع كامل مع تخزين مسارات دون إنترنت.', badge: 'Google Play' },
      { name: 'لوحة ويب', desc: 'مركز القيادة الكامل في متصفحك.', badge: 'Web' },
      { name: 'كونسول مكتبي', desc: 'جدار متعدد الشاشات لفرق الاستجابة.', badge: 'Win · Mac' },
    ],
    apiTitle: 'واجهة API مفتوحة وWebhooks', apiDesc: 'ادفع المواقع والتنبيهات والتقارير إلى SAP أو Oracle أو نظامك الخاص.',
  },
  appsPage: {
    eyebrow: 'تطبيقات الجوال', title: 'أسطولك في جيبك.',
    sub: 'تابع ونبه وتصرف من أي مكان — تطبيق ويَك يضع الخريطة الحية والتنبيهات الفورية والتقارير الكاملة على هاتفك.',
    phoneTitle: 'الخريطة الحية على هاتفك',
    phoneDesc: 'تابع كل وحدة لحظياً، وأعد تشغيل المسارات، وأوقف المحركات — كل ذلك من التطبيق.',
    alertsTitle: 'تنبيهات فورية',
    alertsDesc: 'إشعارات لحظة حدوث أي شيء: تجاوز سرعة، إنزال وقود، خروج من النطاق.',
    features: [
      { t: 'تتبع مباشر', d: 'كل الوحدات على خريطة واحدة، تحديث كل 10 ثوانٍ.' },
      { t: 'تنبيهات فورية', d: 'إشعارات فورية للسرعة والوقود والنطاقات.' },
      { t: 'إعادة تشغيل المسار', d: 'أعد تشغيل أي رحلة مع الوقوف والسرعات.' },
      { t: 'التحكم بالنطاقات', d: 'ارسم مناطق واحصل على تنبيهات الدخول والخروج.' },
      { t: 'قطع المحرك عن بُعد', d: 'أوقف أي وحدة بأمان من التطبيق.' },
      { t: 'تقارير متنقلة', d: 'رحلات ووقود وتقييم سائقين بصيغة PDF.' },
    ],
  },
  testimonials: {
    eyebrow: 'من الميدان', title: 'مشغّلون لا يعتبرون البدائل.',
    items: [
      { q: 'توقف سرق الوقود تماماً في الشهر الذي ثبتنا أجهزة ويَك على 140 صهريجاً.', n: 'حسين أ.', r: 'مدير أسطول · نقل نفط البصرة' },
      { q: 'استعدنا حفارة مسروقة في 40 دقيقة. فريق الاستجابة وجّهنا خطوة بخطوة.', n: 'ديلان م.', r: 'عمليات · مجموعة إنشاءات، أربيل' },
      { q: 'الصيانة كانت تخميناً. الآن المنصة تحجز الخدمة قبل أن تتعطل الشاحنة.', n: 'علي ت.', r: 'مدير لوجستيك · بغداد' },
    ],
  },
  ctaBand: { title: 'أسطولك مرئي خلال 24 ساعة.', sub: 'تركيب في كل العراق خلال يوم واحد. خطط شهرية بلا التزام.', cta1: 'ابدأ الآن', cta2: 'تواصل معنا', cta3: 'حمّل التطبيق' },
  footer: { tag: 'تتبع أساطيل فضائي دقيق للعراق.', platform: 'المنصة', company: 'الشركة', contactCol: 'التواصل', follow: 'تابعنا', rights: '© 2026 ويَك جي بي إس. جميع الحقوق محفوظة.', address: 'إمباير وورلد، أربيل · العراق' },
  about: {
    eyebrow: 'من نحن', title: 'ويَك جي بي إس — دقة عراقية بتقنية عالمية.',
    story: [
      'ويَك جي بي إس شركة عراقية متخصصة بأنظمة تتبع المركبات الذكية وإدارة الأسطول. نبني ونشغّل منصة متكاملة — أجهزة تتبع فضائية، اتصال 4G، برمجيات ودعم — مصممة لواقعية الطرق والأعمال في العراق.',
      'من سيارة أجرة واحدة إلى أساطيل لوجستية وطنية، يرى عملاؤنا كل مركبة لحظياً، ويقطعون سرق الوقود، ويدرّبون السائقين، ويؤتمتون الصيانة — كل ذلك من حساب واحد بسيط على الويب والموبايل.',
    ],
    vision: { t: 'رؤيتنا', d: 'أن نكون منصة التتبع التي تثق بها كل أسطول عراقي — أدق وأسرع وأذكى نظام في المنطقة.' },
    mission: { t: 'رسالتنا', d: 'منح أصحاب الأساطيل رؤية وسيطرة كاملة عبر تقنية حديثة بسيطة وموثوقة وبسعر عادل.' },
    why: {
      t: 'لماذا ويَك جي بي إس؟', items: [
        { t: 'تغطية عراقية كاملة', d: 'أجهزة وتركيب ودعم في كل المحافظات.' },
        { t: 'دعم حقيقي 24/7', d: 'مهندسون في أربيل وبغداد ليلاً ونهاراً.' },
        { t: 'أسعار صادقة', d: 'خطط شهرية واضحة بلا رسوم خفية.' },
        { t: 'أجهزة مثبتة', d: 'وحدات IP67 متعددة الأقمار معتمدة ضد السرقة.' },
      ],
    },
  },
  solutions: {
    eyebrow: 'الحلول', title: 'حلول لكل عمل يتحرك.', 
    sub: 'اختر نوع أسطولك — ننشر الأجهزة والحساسات والتقارير المناسبة له.',
    items: [
      { t: 'أساطيل الشركات', d: 'سيارات صالون ومديرين مع تعريف السائق والرحلات وضبط المصاريف.' },
      { t: 'الشاحنات والصهاريج', d: 'مراقبة النقل الطويل مع حماية الوقود وحساسات الحرارة.' },
      { t: 'السيارات والتاكسيات', d: 'أجهزة اقتصادية بخريطة حية وتنبيهات سرعة وسجل رحلات.' },
      { t: 'الدراجات والتك تك', d: 'وحدات صغيرة ضد الماء مع تنبيهات عبث للتوصيل السريع.' },
      { t: 'النقل والتوزيع', d: 'التزام المسارات وإثبات التوصيل وحساسات الباب والحمولة.' },
      { t: 'المؤسسات الحكومية', d: 'سيرفرات آمنة وسجلات تدقيق وسياسات استخدام لأساطيل القطاع العام.' },
      { t: 'المشاريع والآليات الثقيلة', d: 'حماية الحفارات والمولدات مع عدادات ساعات العمل.' },
    ],
  },
  servicesPage: {
    eyebrow: 'الخدمات والحلول', title: 'كل ما يحتاجه أسطول حديث.',
    sub: 'عشر خدمات، منصة واحدة — هندسة لأساطيل لا تحتمل التوقف.',
    items: [
      { t: 'التتبع المباشر', d: 'مواقع لحظية كل 10 ثوانٍ بدقة 2.5 متر.' },
      { t: 'إدارة الأسطول', d: 'مجموعات وأدوار وصلاحيات لفريقك كاملاً.' },
      { t: 'تقارير الرحلات', d: 'سجل كامل وإعادة تشغيل لكل مسار وتوقف.' },
      { t: 'التنبيهات الذكية', d: 'تنبيهات سرعة ووقود ونطاق وصيانة فورية.' },
      { t: 'مراقبة السرعة', d: 'حدود لكل منطقة مع سجل فوري للتجاوزات.' },
      { t: 'مراقبة الوقود', d: 'المستوى والاستهلاك وكشف السرقة لحظياً.' },
      { t: 'تحديد السائق', d: 'اعرف من يقود ماذا، بمفاتيح iButton / RFID.' },
      { t: 'Geofence', d: 'مناطق افتراضية مع تنبيهات دخول وخروج.' },
      { t: 'إدارة الصيانة', d: 'جداول خدمة وتذكيرات وتتبع تكاليف.' },
      { t: 'ربط التطبيق والويب', d: 'حساب واحد عبر الموبايل والمتصفح والديسكتوب.' },
    ],
  },
  offers: {
    eyebrow: 'العروض الفنية', title: 'العروض الفنية وحلول المشاريع.',
    sub: 'باقات جاهزة لتتبع GPS وإدارة الأسطول ومشاريع العد — مع ملفات PDF تفصيلية للتحميل.',
    cards: [
      { id: 'gps', name: 'عرض أنظمة GPS', d: 'أجهزة التتبع والتركيب والوصول للمنصة للسيارات والفانات والأساطيل الخفيفة.', includes: ['جهاز ويَك تراكر 4G', 'طقم تركيب كامل', 'المنصة + تطبيقات الجوال', 'ضمان 12 شهراً'], price: 'من $9 / مركبة / شهر' },
      { id: 'fleet', name: 'عرض إدارة الأسطول', d: 'مركز القيادة الكامل: مراقبة الوقود والنطاقات وتعريف السائق وجدولة الصيانة.', includes: ['كل ما في عرض GPS', 'حساسات وقود وحماية', 'تعريف السائق (iButton/RFID)', 'مدير حساب مخصص'], price: 'من $14 / مركبة / شهر', popular: true },
      { id: 'projects', name: 'عرض المشاريع والعد', d: 'حلول مخصصة للآليات الثقيلة وعد المركبات والانتشار الحكومي واسع النطاق.', includes: ['أجهزة ثقيلة / ATEX', 'عدادات ساعات وحساسات', 'خيار سيرفر داخلي', 'SLA وتدريب مخصص'], price: 'عرض حسب الطلب' },
    ],
    pdf: 'تحميل PDF', request: 'اطلب عرضاً فنياً',
    calc: { title: 'حاسبة عائد الأسطول', sub: 'مرر لحجم أسطولك وشاهد الأرقام.', vehicles: 'المركبات', monthlyCost: 'التكلفة الشهرية التقديرية', fuelSave: 'وفورات الوقود الشهرية المتوقعة', note: 'بناءً على متوسط وفورات 28% الذي أبلغت عنه أساطيل عراقية.', cta: 'احصل على عرض دقيق' },
    promo: { title: 'تركيب مجاني في أربيل وبغداد', sub: 'للأساطيل من 10 مركبات وأكثر هذا الربع. فنيون معتمدون وبدون توقف.' },
  },
  maintenance: {
    eyebrow: 'الصيانة والتركيب', title: 'يتركب بالأخصائيين. ويُصان بالأخصائيين.',
    sub: 'من أول سلك إلى المعايرة السنوية — أجهزة ويَك تبقى في ذروة الجاهزية.',
    timeline: [
      { t: 'منفذ OBD-II / توصيل مباشر', d: 'فني معتمد يثبت الجهاز ويخفيه. 20 دقيقة لكل مركبة.' },
      { t: 'معايرة الحساسات', d: 'حساسات الوقود والحرارة والإشعال تُعاير على أسطولك بالضبط.' },
      { t: 'تثبيت الاتصال الفضائي', d: 'الجهاز يقفل على الساتيلايت و4G-LTE ويرسل أول إحداثية.' },
      { t: 'اقتران التطبيق', d: 'فريقك يحصل على وصول حي على iOS وأندرويد والويب.' },
    ],
    hardware: {
      title: 'أجهزة صُنعت لطرق العراق',
      items: [
        { name: 'ويَك تراكر 4G', spec: 'IP67 ضد الماء · 4G-LTE · تحديث 10 ثوانٍ' },
        { name: 'حساس وقود', spec: 'سعة · دقة ±1%' },
        { name: 'منارة بلوتوث', spec: 'اقتران المقطورات والحمولات' },
        { name: 'زر استغاثة SOS', spec: 'سلامة السائق · استجابة فورية' },
      ],
    },
    diag: {
      title: 'فحص الجهاز في 60 ثانية', sub: 'ثلاثة أسئلة تحدد أغلب المشاكل قبل أن تتصل بالدعم.',
      q1: { q: 'ما لون ضوء GPS؟', opts: ['أزرق ثابت', 'أحمر يومض', 'مطفأ'] },
      q2: { q: 'أعمدة إشارة الشبكة في التطبيق؟', opts: ['كاملة', 'ضعيفة', 'لا شيء'] },
      q3: { q: 'جهد بطارية المركبة؟', opts: ['12 فولت+', 'أقل من 12', 'غير معروف'] },
      resultOk: 'كل شيء سليم — جهازك بصحة جيدة.', resultFix: 'وجدنا حلاً محتملاً — احجز فنياً بالأسفل.',
      btn: 'شغّل الفحص', again: 'أعد الفحص',
    },
    form: { title: 'احجز فنياً إلى موقعك', name: 'الاسم الكامل', phone: 'رقم الهاتف', city: 'المدينة', vehicles: 'عدد المركبات', date: 'التاريخ المفضل', notes: 'ملاحظات', submit: 'اطلب موعداً', success: 'استلمنا طلبك — سيتصل بك فريقنا خلال ساعتين.' },
  },
  services: { hero: { eyebrow: 'الصيانة', title: 'مراكز الخدمة والمعايرة.', sub: 'فنيون معتمدون في أربيل وبغداد والسليمانية.' } },
  contact: {
    eyebrow: 'اتصل بنا', title: 'تحدث مع مهندس أساطيل — لا مركز اتصالات.',
    sub: 'المبيعات والعروض التوضيحية والشراكات. متوسط الرد: ساعتان.',
    form: { name: 'الاسم الكامل', phone: 'الهاتف', email: 'البريد الإلكتروني', message: 'كيف نساعدك؟', submit: 'أرسل الرسالة', success: 'أُرسلت الرسالة — سنرد خلال ساعتين.', error: 'لم تُرسل الرسالة. حاول مجدداً.' },
    offices: { title: 'المكاتب', items: [{ city: 'أربيل — المركز', addr: 'إمباير وورلد، برج 2' }, { city: 'بغداد', addr: 'الكرادة، شارع الرشيد' }, { city: 'السليمانية', addr: 'المنطقة الصناعية، بكرة جو' }] },
    channels: { phone: 'المبيعات والدعم', whatsapp: 'واتساب', email: 'البريد', phoneV: '+964 750 000 0000', emailV: 'hello@wiyakgps.com', whatsappV: 'محادثة الآن', social: 'وسائل التواصل' },
  },
  support: {
    eyebrow: 'الدعم الفني', title: 'عالق؟ نحن نعمل على الأمر فعلاً.',
    sub: 'مهندسون 24/7 في أربيل وبغداد. التذاكر تُجاب في أقل من 30 دقيقة.',
    form: { title: 'افتح تذكرة', name: 'الاسم الكامل', phone: 'الهاتف', email: 'البريد الإلكتروني', device: 'الجهاز / معرف المركبة', priority: 'الأولوية', priorities: ['منخفضة', 'عادية', 'حرجة'], message: 'صف المشكلة', submit: 'أرسل التذكرة', success: 'فُتحت التذكرة — سيرد مهندس الدعم خلال 30 دقيقة.' },
    faq: { title: 'قاعدة المعرفة', items: [] },
    remote: { title: 'دعم سطح المكتب عن بُعد', sub: 'مهندسونا يتصلون بكونسول المكتب لديك بموافقتك — AnyDesk أو TeamViewer، برموز جلسة وسجل كامل.', download: 'تحميل AnyDesk' },
    hotline: { title: 'خط ساخن للمركبات المسروقة', sub: 'فريق استجابة 24/7 ينسق مع الشرطة وفرق الاستعادة.', number: '+964 750 000 0000', call: 'اتصل الآن' },
    hours: { title: 'ساعات العمل', sales: 'المبيعات: السبت – الخميس، 9:00 – 18:00', support: 'الدعم الفني والخط الساخن: 24/7' },
    videos: { title: 'فيديوهات وشروحات مساعدة', items: ['تنصيب تطبيق الجوال', 'قراءة الخريطة الحية', 'إعداد تنبيهات النطاق'] },
  },
  faqPage: {
    eyebrow: 'الأسئلة الشائعة', title: 'الأسئلة الشائعة.',
    sub: 'كل ما يسأله عملاؤنا قبل أول تركيب.',
    items: [
      { q: 'ما هو WiyakGPS؟', a: 'منصة ذكية لتتبع المركبات وإدارة الأسطول: أجهزة تتبع تثبت في مركباتك، مع تطبيقات ويب وموبايل تعرض المواقع الحية والمسارات والتنبيهات والتقارير.' },
      { q: 'كيف يعمل جهاز التتبع؟', a: 'يستقبل الجهاز إشارات أقمار GPS لتحديد موقعه، ثم يرسلها عبر 4G-LTE إلى منصة ويَك — كل 10 ثوانٍ أثناء الحركة.' },
      { q: 'هل يعمل في جميع المحافظات؟', a: 'نعم. التغطية تشمل كل العراق — المدن والطرق السريعة والممرات الريفية — مع تجوال تلقائي للدول المجاورة.' },
      { q: 'هل يمكن متابعة أكثر من مركبة؟', a: 'نعم. حساب واحد يراقب أسطولاً كاملاً — مئات الوحدات — مجمعة كما تحب، مع تنبيهات وتقارير لكل مركبة.' },
      { q: 'هل توجد تنبيهات سرعة؟', a: 'نعم. حدد حدود السرعة لكل منطقة أو مركبة واحصل على تنبيهات فورية مع سجل كامل للتجاوزات.' },
      { q: 'هل توجد تقارير؟', a: 'رحلات ووقود وسلوك سائقين وصيانة وتقارير مخصصة — كلها قابلة للتصدير PDF أو Excel.' },
      { q: 'هل يعمل على الهاتف؟', a: 'نعم — تطبيقات أصلية لـ iOS وAndroid بخريطة حية وتنبيهات ولوحة كاملة، بالإضافة إلى نسخة الويب لأي متصفح.' },
    ],
  },
  download: {
    eyebrow: 'التحميل', title: 'ويَك جي بي إس على كل شاشة تملكها.',
    sub: 'تطبيقات أصلية للميدان ولوحة ويب للمكتب وكونسول للحائط.',
    qr: { title: 'اقترن هاتفك', sub: 'امسح لفتح تطبيق الجوال على هذا الجهاز.' },
    docs: { title: 'مستندات ومراجع', items: [{ k: 'كتيب الاستخدام (PDF)', href: '/pdf/wiyakgps-user-manual.pdf' }, { k: 'بروشور الشركة (PDF)', href: '/pdf/wiyakgps-brochure.pdf' }] },
    notes: { title: 'ملاحظات الإصدار', version: 'v4.2.1', date: 'فبراير 2026', items: ['تشغيل الممرات الحية بدقة 10 ثوانٍ', 'تقرير جنائي لإنزال الوقود بتصدير PDF', 'واجهة كردية سورانية — RTL كامل'] },
    reqs: { title: 'متطلبات النظام', rows: [{ k: 'iOS', v: '14.0+' }, { k: 'Android', v: '8.0+' }, { k: 'Windows', v: '10 / 11 x64' }, { k: 'macOS', v: '13+ Apple Silicon' }, { k: 'Web', v: 'Chrome, Edge, Safari' }] },
    badges: { ios: 'حمّله من App Store', android: 'احصل عليه من Google Play', apk: 'APK مباشر', win: 'كونسول ويندوز', mac: 'كونسول ماك', web: 'افتح لوحة الويب' },
  },
  login: {
    title: 'تسجيل دخول المنصة', sub: 'ادخل إلى لوحة ويَك جي بي إس.',
    username: 'اسم المستخدم أو البريد', password: 'كلمة المرور', btn: 'تسجيل الدخول', forgot: 'نسيت كلمة المرور؟',
    forgotMsg: 'اتصل على +964 750 000 0000 — سيعيد فريقنا تعيينها خلال دقائق.',
    welcome: 'مرحباً بعودتك!', error: 'اسم مستخدم أو كلمة مرور خاطئة.', adminNote: 'حساب تجريبي: admin@wiyakgps.com',
  },
  admin: {
    title: 'الإدارة · الرسائل', loginTitle: 'دخول المشرف', sub: 'مخصص لموظفي ويَك جي بي إس.',
    email: 'البريد الإلكتروني', password: 'كلمة المرور', btn: 'تسجيل الدخول', error: 'بريد أو كلمة مرور خاطئة.', logout: 'تسجيل الخروج',
    filterAll: 'الكل', search: 'بحث…', export: 'تصدير CSV', empty: 'لا رسائل بعد.',
    cols: { type: 'النوع', name: 'الاسم', contact: 'التواصل', message: 'الرسالة', status: 'الحالة', date: 'التاريخ' },
    types: { contact: 'اتصال', support: 'تذكرة دعم', maintenance: 'صيانة' },
    statuses: { pending: 'معلق', in_progress: 'قيد المعالجة', resolved: 'منجز' },
  },
  assistant: {
    title: 'مساعد WiyakGPS', welcome: 'أهلاً بك! أنا المساعد الذكي لـ WiyakGPS. اسألني عن أجهزة التتبع أو العروض أو الأسعار أو التركيب أو الدعم.',
    placeholder: 'اكتب سؤالك…', send: 'إرسال', typing: 'يكتب…', error: 'المساعد غير متاح حالياً. حاول مرة أخرى أو تواصل معنا عبر واتساب.',
    suggestions: ['ما هي عروضكم وأسعارها؟', 'كيف يعمل جهاز التتبع؟', 'كيف أحجز موعد تركيب؟'],
    whatsapp: 'تواصل عبر واتساب', open: 'اسأل المساعد', close: 'إغلاق', reset: 'محادثة جديدة',
  },
  common: { submitting: 'جارٍ الإرسال…', required: 'يرجى ملء الحقول المطلوبة.', error: 'حدث خطأ. حاول مجدداً.', vehicles: 'مركبة' },
};
